export default "__VITE_ASSET__H7$NLrRu__"